import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import '../pages/css/Home.css';
import '../pages/css/ProductPageUpdated.css';
import banner from '../images/hrias-banner.jpg';
import dashboard from '../images/dash.gif';
import servicebg from '../images/testimonial-bg.png';
import { FaLaptopCode, FaBrain, FaGreaterThan, FaLessThan, FaPlay  } from 'react-icons/fa';
import { GiRobotAntennas } from 'react-icons/gi';
import { MdOutlineRocketLaunch } from 'react-icons/md';
import customDev from '../images/Hrias-Custom_Development.png';
import intentSignal from '../images/Hrias-Intent_Signal.png';
import multiChannel from '../images/Hrias-Channel_Sequence.png';
import notSpam from '../images/Hrias-Not_Spam.png';
import aiPersonalization from '../images/Hrias-Ai_Template.png';
import prospects from '../images/Hrias-filters.png';
import multiChannelOutreach from '../images/Hrias-Multichannel.png';
import marketing2 from '../images/Hrias-video-thumb.jpg';
import marketing3 from '../images/Hrias-video.mp4';
import marketing4 from '../images/marketing4.svg';
import ct1 from '../images/ct1.jpg';
import ct2 from '../images/ct5.jpg';
import ct3 from '../images/ct2.jpg';
import ct4 from '../images/ct7.jpg';
import cTOne from '../images/kpmg.png';
import cTTwo from '../images/deloite.png';
import cTThree from '../images/berkshire.png';
import cTFive from '../images/pwc.jpg';
import cTSix from '../images/microsoft.png';
import cTSeven from '../images/JPMorgan.png';
import cTEight from '../images/Goldman.jpg';
import review6 from '../images/review6.jpg';
import cTFour from '../images/Google.png';
import { Container, Row, Col, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaRegCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

function ProductPage() {
  const navigate = useNavigate();

  const iconStyle = {
    backgroundColor: "#28a745",
    color: "#fff",
    borderRadius: "50%",
    padding: "4px",
    marginRight: "8px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
  };


  const faqColumn1 = [
    {
      question: "Why choose Hrias over other sales automation tools?",
      answer:
        "Hrias combines AI-powered personalization, multi-mailbox scaling, and ML-driven reply handling in one seamless platform. Unlike generic tools, Hrias is designed to help you scale intelligently while keeping outreach human and relevant."
    },
    {
      question: "Does Hrias offer support after I start using the platform?",
      answer:
        "Absolutely. We offer onboarding assistance, live chat, documentation, and dedicated support to help you make the most of the platform — whether you're just launching or managing multiple campaigns."
    },
    {
      question: "What types of businesses use Hrias?",
      answer:
        "Hrias is trusted by sales teams, agencies, startups, and outbound SDRs who want smarter outreach. Whether you're a solo founder or a team of 50+, Hrias adapts to your scale and sales style."
    },
    {
      question: "What are the benefits of using Hrias for outreach automation?",
      answer:
        "Hrias helps you reach more qualified leads with less manual effort. You’ll enjoy better inbox placement, higher engagement, AI-personalized messages, warm-up automation, and full CRM sync — all in one place."
    },
    {
      question: "How much does Hrias cost?",
      answer:
        "Your final pricing depends on how many mailboxes, contacts, and features you need. No hidden fees — just transparent pricing you can control in real-time with our plan calculator."
    },
    {
      question: "Does Hrias offer cold email warm-up services?",
      answer:
        "Yes. Hrias has built-in domain and mailbox warm-up to protect your sender reputation. We auto-rotate sending, simulate replies, and monitor your health score — no separate tools needed."
    },
    {
      question: "How does Hrias handle communication and reply tracking?",
      answer:
        "Hrias provides a unified inbox where you can see all replies across every mailbox and campaign. With ML-based tagging, we categorize replies (hot leads, objections, out-of-office, etc.) so you focus only on what matters."
    }
  ];

  const faqColumn2 = [
    {
      question: "What technologies does Hrias use?",
      answer:
        "Hrias is built on a modern, scalable tech stack including Node.js, React, Firebase, Postgres, and OpenAI-powered personalization modules. Our infrastructure is optimized for speed, security, and mass parallel delivery."
    },
    {
      question: "What’s the outreach workflow with Hrias?",
      answer:
        "You describe your target audience and message tone. Hrias then auto-generates emails, rotates mailboxes, warms up domains, and tracks replies — all while syncing intent scores to your CRM. Just set your goal and watch it scale."
    },
    {
      question: "How does Hrias ensure timely inbox delivery?",
      answer:
        "We combine smart sending schedules, AI-generated copy, domain warm-ups, and auto-rotated mailboxes to ensure emails land in inboxes. Our engine monitors blacklist risk and adjusts sending dynamically to protect your deliverability."
    },
    {
      question: "What types of outreach does Hrias support?",
      answer:
        "Cold email, nurture campaigns, retargeting flows, intent-based reactivation, and custom follow-up sequences based on user actions — all driven by AI and behavioral triggers."
    },
    {
      question: "Will I have a dedicated success manager?",
      answer:
        "Yes, on all business plans. We assign you a success manager to guide setup, strategy, and optimization. From onboarding to campaign scaling, you're never alone with Hrias."
    },
    {
      question: "How does Hrias protect my data and privacy?",
      answer:
        "Hrias is GDPR-compliant and uses bank-grade encryption across all systems. We sign NDAs on request and never share your leads, data, or content. Your outreach is 100% your own."
    },
    {
      question: "Can Hrias work in my time zone or region?",
      answer:
        "Yes. Our platform is cloud-based and runs 24/7. We have clients in North America, Europe, Asia, and beyond — and our support is timezone-flexible depending on your plan."
    }
  ];

  const fadeInUp = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
  };

  const openVideoPopup = () => {
    Swal.fire({
      html: `
        <div style="position: relative;">
          <iframe
            width="50%"
            height="350"
            src=${marketing3} type="video/mp4"
            frameborder="0"
            allow="autoplay; encrypted-media"
            allowfullscreen
            style="border-radius:10px;"
          ></iframe>
        </div>
      `,
      background: "#111",
      width: 750,
      padding: 0,
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        popup: "video-popup-style",
        closeButton: "video-popup-close"
      }
    });
  };

  return (
    <>
      <section className="product-section">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} className="text-center">

              {/* Heading */}
              <h2
                className="product-heading fw-bold mb-3"
                style={{
                  fontFamily: 'Poppins, sans-serif',
                  fontSize: '1.9rem',
                  lineHeight: '1.5',
                }}
              >
                <span style={{ color: '#0d6efd' }}>HRIAS</span>: Your
                <span style={{ color: '#6610f2' }}> All-in-One</span>{' '}
                AI-powered{' '}
                <span style={{ color: '#0d6efd' }}>sales engagement tool</span> built to drive{' '}
                <span style={{ color: '#6610f2' }}>qualified replies</span>{' '}
                and{' '}
                <span style={{ color: '#0d6efd' }}>consistent sales</span>.
              </h2>

              {/* Subheading */}
              <p
                className="product-subheading text-muted"
                style={{
                  fontFamily: 'Poppins, sans-serif',
                  fontSize: '1.05rem',
                  lineHeight: '1.8',
                  fontWeight: '800',
                }}
              >
                Automate personalized outreach across every channel:{' '} <br />
                <span style={{ color: '#0d6efd' }}>Email</span>,{' '}
                <span style={{ color: '#6610f2' }}>LinkedIn</span>,{' '}
                <span style={{ color: '#198754' }}>WhatsApp</span>,{' '}
                <span style={{ color: '#fd7e14' }}>Instagram</span>,{' '}
                <span style={{ color: '#dc3545' }}>Facebook</span> &{' '}
                <span style={{ color: '#20c997' }}>Calls</span>.
              </p>

              {/* Button */}
              <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                <Button className="product-btn" onClick={() => navigate("/contact-us-hrias")}>Contact Sales</Button>
              </motion.div>

              {/* Ratings Box */}
              <div className="rating-box mt-4">
                {/* Google Play Rating */}
                <div className="rating-item me-4">
                  <div className="rating-top">
                    <img
                      src={cTFour}
                      alt="Google Play"
                      className="rating-logo"
                    />
                    <span className="rating-score">4.8</span>
                  </div>
                  <div className="rating-stars">⭐⭐⭐⭐⭐</div>
                </div>

                {/* Clutch Rating */}
                <div className="rating-item">
                  <div className="rating-top">
                    <img
                      src={review6}
                      alt="Clutch"
                      className="rating-logo"
                    />
                    <span className="rating-score">4.9</span>
                  </div>
                  <div className="rating-stars">⭐⭐⭐⭐⭐</div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="container overlap-image-section">
        <div className="text-center">
          <img
            src={multiChannelOutreach}
            alt="Hrias Dashboard Preview"
            className="img-fluid overlap-img"
          />
        </div>
      </section>

      <section className="container my-5 partner-section">
        {/* Heading */}
        <h5 className="text-center partner-heading">
          Trusted by <span style={{ color: '#fd7e14' }}>6000+</span> Industry Leaders
        </h5>

        {/* Logo Row */}
        <div className="d-flex justify-content-center align-items-center flex-wrap gap-4 mt-4">
          <img src={cTOne} alt="KPMG" className="partner-logo" style={{ width: '120px', height: 'auto' }} />
          <img src={cTTwo} alt="Deloitte" className="partner-logo" style={{ width: '130px', height: 'auto' }} />
          <img src={cTThree} alt="Berkshire" className="partner-logo" />
          <img src={cTFour} alt="Google" className="partner-logo" />
          <img src={cTFive} alt="PwC" className="partner-logo" />
          <img src={cTSix} alt="Microsoft" className="partner-logo" />
        </div>
      </section>

      {/* <section className="container my-5">
        <div className="row align-items-center">

          <div className="col-md-6 position-relative text-center">
            <img
              src={marketing2}
              alt="Case Study Thumbnail"
              className="rounded shadow"
              style={{ maxWidth: "60%", height: "auto" }}
            />


            <div
              onClick={openVideoPopup}
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                background: "rgba(0,0,0,0.5)",
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                transition: "0.3s"
              }}
              onMouseOver={(e) => (e.currentTarget.style.background = "rgba(0,0,0,0.7)")}
              onMouseOut={(e) => (e.currentTarget.style.background = "rgba(0,0,0,0.5)")}
            >
              <FaPlay style={{ fontSize: "32px", color: "#fff" }} />
            </div>
          </div>

          <div className="col-md-6 mt-4 mt-md-0">
            <p className="fw-bold" style={{ color: "#0d6efd", fontSize: '20px' }}>Case Study</p>

            <h1 className="fw-bold" style={{ lineHeight: "1.3" }}>
              <span style={{color: "#0d6efd" }}>Nervana Co.</span> Generates <span style={{color: "#0d6efd" }}>$300k</span> in Pipeline and Achieves <span style={{color: "#0d6efd" }}>89% ROI</span> with <span style={{color: "#0d6efd" }}>Hrias by Peregrinee</span>
            </h1> 

            <button
              onClick={openVideoPopup}
              className="btn btn-primary mt-4"
              style={{
                backgroundColor: "#134373",
                borderRadius: "25px",
                border: "none",
                padding: "12px 28px",
                fontWeight: "600"
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#5197dc")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#134373")}
            >
              Watch Case Study
            </button>
          </div>
        </div>

        <style>{`
        .video-popup-close {
          color: white !important;
          font-size: 22px !important;
          position: absolute !important;
          top: 10px !important;
          right: 12px !important;
        }
        .video-popup-style {
          border-radius: 12px !important;
        }
      `}</style>
      </section> */}

      <section className="container my-5 client-review-section">
        <div className="row align-items-center">
          {/* Left side - client image */}
          {/* <div className="col-12 col-md-3 text-center">
            <img
              src="https://cdn.prod.website-files.com/5de921a1902d8d8b7a99f774/68a847c65471ebc4a37514d5_paul-aubry.png" // replace with your client's photo
              alt="Client"
              className="client-img"
            />
          </div> */}

          {/* Right side - review text */}
          <div className="col-12 col-md-12">
            <p className="client-review">
              “Hrias has completely transformed how we handle our marketing automation.
              Their AI-driven workflows helped us improve lead quality and reduce campaign costs dramatically.
              Highly recommended for any business looking to scale smartly!”
            </p>
             <h3 className="client-name">Dan M.</h3>
                        <p className="client-position">Agency Founder</p>

          </div>
        </div>
      </section>

      <section className="curved-divider"></section>

      {/* Light Blue Section */}
      <section className="light-blue-section py-5">
        <div className="container">
          <h2 className="text-center fw-bold mb-5 mt-5">Find, enrich, & reach qualified leads from one platform.</h2>

          {/* Box 1 */}
          <div className="info-box d-flex flex-column flex-md-row align-items-center mb-5">
            <div className="info-img col-md-6 p-3">
              <img
                src={prospects}
                alt="Client 1"
                className="img-fluid rounded bg-white p-3 shadow-sm"
              />
            </div>

            <div className="info-content col-md-6 p-4 text-md-start">
              <h4 className="fw-bold mb-3">Find Ready-to-Buy Prospects with Hrias</h4>
              <p className="text-muted fw-semibold mb-3" style={{ fontFamily: 'Poppins, sans-serif', lineHeight: '1.7' }}>
                Access a powerful verified lead database and use smart filters to spot companies and
                decision-makers matching your ICP.
              </p>
              <p className="text-muted fw-semibold mb-4" style={{ fontFamily: 'Poppins, sans-serif', lineHeight: '1.7' }}>
                With Hrias’s built-in feature, get <span style={{ fontWeight: "bold" }}>90% verified</span> emails and phone numbers from top available sources — all in one click.
              </p>
              <button className="btn btn-primary px-4 py-2" onClick={() => navigate("/contact-us-hrias")}>Contact Sales</button>
            </div>
          </div>


          {/* Box 2 */}
          <div className="info-box d-flex flex-column flex-md-row-reverse align-items-center mb-5">
            <div className="info-img col-md-6 p-3">
              <img
                src={aiPersonalization}
                alt="AI Personalization"
                className="img-fluid rounded bg-white p-3 shadow-sm"
              />
            </div>

            <div className="info-content col-md-6 p-4 text-md-start">
              <h4 className="fw-bold mb-3">Personalize at Scale with Human-like AI</h4>
              <p className="text-muted fw-semibold mb-3" style={{ fontFamily: 'Poppins, sans-serif', lineHeight: '1.7' }}>
                Hrias AI to craft messages that feel personal — not robotic. Our system automatically gathers lead insights from
                LinkedIn, websites, and other trusted sources, saving you hours of manual research.
              </p>
              <p className="text-muted fw-semibold mb-4" style={{ fontFamily: 'Poppins, sans-serif', lineHeight: '1.7' }}>
                With dynamic variables, your emails, visuals, and landing pages adapt in real time to each prospect — ensuring every
                interaction feels truly one-to-one.
              </p>
              <button className="btn btn-primary px-4 py-2" onClick={() => navigate("/contact-us-hrias")}>Contact Sales</button>
            </div>
          </div>


          {/* Box 3 */}
          <div className="info-box d-flex flex-column flex-md-row align-items-center mb-5">
            <div className="info-img col-md-6 p-3">
              <img
                src={multiChannel}
                alt="Multi-Channel Automation"
                className="img-fluid rounded bg-white p-3 shadow-sm"
              />
            </div>

            <div className="info-content col-md-6 p-4 text-md-start">
              <h4 className="fw-bold mb-3">Run Multi-Channel Sequences from One Dashboard</h4>
              <p className="text-muted fw-semibold mb-3" style={{ fontFamily: 'Poppins, sans-serif', lineHeight: '1.7' }}>
                Hrias lets you automate and manage outreach across multiple platforms — from one unified dashboard.
                Launch personalized sequences combining emails, LinkedIn actions, WhatsApp messages, and even calls — all without switching tabs.
              </p>
              <p className="text-muted fw-semibold mb-4" style={{ fontFamily: 'Poppins, sans-serif', lineHeight: '1.7' }}>
                Track every lead interaction in a single smart inbox, monitor performance across senders, and boost conversions with precise, data-driven engagement.
              </p>
              <button className="btn btn-primary px-4 py-2" onClick={() => navigate("/contact-us-hrias")}>Contact Sales</button>
            </div>
          </div>


          {/* Box 4 */}
          <div className="info-box d-flex flex-column flex-md-row-reverse align-items-center mb-5">
            <div className="info-img col-md-6 p-3">
              <img
                src={notSpam}
                alt="Email Deliverability"
                className="img-fluid rounded bg-white p-3 shadow-sm"
              />
            </div>

            <div className="info-content col-md-6 p-4 text-md-start">
              <h4 className="fw-bold mb-3">Ensure Your Outreach Never Lands in Spam</h4>
              <p className="text-muted fw-semibold mb-3" style={{ fontFamily: 'Poppins, sans-serif', lineHeight: '1.7' }}>
                With Hrias, your messages are built to reach inboxes — not spam folders. Our smart deliverability system
                automatically optimizes sender reputation, email patterns, and timing to keep your outreach safe and authentic.
              </p>
              <p className="text-muted fw-semibold mb-4" style={{ fontFamily: 'Poppins, sans-serif', lineHeight: '1.7' }}>
                The built-in Hrias Deliverability Engine continuously warms up your domain, adjusts sending behavior, and
                provides actionable tips — ensuring your communication always lands where it matters most.
              </p>
              <button className="btn btn-primary px-4 py-2" onClick={() => navigate("/contact-us-hrias")}>Contact Sales</button>
            </div>
          </div>


          {/* Box 5 */}
          <div className="info-box d-flex flex-column flex-md-row align-items-center mb-5">
            <div className="info-img col-md-6 p-3">
              <img
                src={intentSignal}
                alt="Intent Signals"
                className="img-fluid rounded bg-white p-3 shadow-sm"
              />
            </div>

            <div className="info-content col-md-6 p-4 text-md-start">
              <h4 className="fw-bold mb-3">Powered by Hrias Intent Signals</h4>
              <p className="text-muted fw-semibold mb-3" style={{ fontFamily: 'Poppins, sans-serif', lineHeight: '1.7' }}>
                Hrias helps you make data-driven decisions by detecting live buying intent. Get real-time updates whenever your
                target companies post new jobs, publish press releases, launch products, or get featured in the news.
              </p>
              <p className="text-muted fw-semibold mb-4" style={{ fontFamily: 'Poppins, sans-serif', lineHeight: '1.7' }}>
                Access detailed company insights including size, employee count, tech stack, revenue, and location — all in one
                dashboard. With Hrias, you always know which prospects are most likely to convert, and when to engage.
              </p>
              <button className="btn btn-primary px-4 py-2" onClick={() => navigate("/contact-us-hrias")}>Contact Sales</button>
            </div>
          </div>

          <div className="info-box d-flex flex-column flex-md-row-reverse align-items-center mb-5">
            <div className="info-img col-md-6 p-3">
              <img
                src={customDev}
                alt="Custom Development"
                className="img-fluid rounded bg-white p-3 shadow-sm"
              />
            </div>

            <div className="info-content col-md-6 p-4 text-md-start">
              <h4 className="fw-bold mb-3">Custom Development Tailored to Your Requirements</h4>
              <p
                className="text-muted fw-semibold mb-3"
                style={{ fontFamily: 'Poppins, sans-serif', lineHeight: '1.7' }}
              >
                Hrias offers fully customized development as an add-on service — built to match your exact business needs.
                Whether you require new integrations, automated workflows, or unique dashboards, our team delivers solutions
                that fit perfectly within your operations.
              </p>
              <p
                className="text-muted fw-semibold mb-4"
                style={{ fontFamily: 'Poppins, sans-serif', lineHeight: '1.7' }}
              >
                Every custom feature is designed, developed, and deployed with the same high standards of scalability,
                performance, and security that power the Hrias ecosystem — ensuring your platform evolves as your goals grow.
              </p>
              <button className="btn btn-primary px-4 py-2" onClick={() => navigate("/contact-us-hrias")}>Contact Sales</button>
            </div>
          </div>


        </div>

        <div className="text-center mt-5">
          <button className="btn btn-primary contact-btn" onClick={() => navigate("/contact-us-hrias")}>Contact Sales</button>
        </div>
      </section>

      <section className="container my-5 pricing-section">
        <div className="text-center mb-5">
          <h2 className="fw-bold">
            Choose <span style={{ color: '#fd7e14' }}>Your</span> Plan <span style={{ color: '#fd7e14' }}>- B2B</span>
          </h2>
          <p className="text-muted">Find the right package that fits your business needs.</p>
        </div>

        <div className="row justify-content-center">
          {/* Box 1 */}
          <div className="col-md-4 mb-4">
            <div className="pricing-box">
              <h4 className="package-name">Starter Plan</h4>

              <button
                className="btn btn-primary mb-3"
                onClick={() => navigate("/contact-us-hrias")}
              >
                Contact Sales
              </button>

              <ul
                className="feature-list"
                style={{ fontFamily: "Poppins, sans-serif", lineHeight: "1.8" }}
              >
                <li>
                  <strong>Data & Lead Generation</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Highly targeted 90% verified contact database
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    50 free verified leads per month — emails, company numbers, LinkedIn IDs and whatsapp numbers
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    1 lead = 1 credit
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Deliverability — 2 sending emails, 1 LinkedIn account, 1 WhatsApp number
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>Automated Outreach & Follow-ups</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Unlimited automated outreach and follow-ups via email
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>Multi-channel Follow-ups</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Auto LinkedIn visits, invites, and messages
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    WhatsApp messages with images
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>AI-powered Personalization</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Custom AI-generated templates for all channels
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>Lead Sync Importer</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Import your leads (up to 50 contacts)
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>Integrated CRM</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Track Open, Reply, and Click-through rates
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Export data as downloadable PDF or CSV
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>Enablement & Support</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    In-app live support
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Dedicated Account Manager
                  </li>
                </ul>
              </ul>
            </div>
          </div>


          {/* Box 2 (Active / Highlighted) */}
          <div className="col-md-4 mb-4">
            <div className="pricing-box active-box position-relative">
              {/* 🔹 Top Selling Tag */}
              <span className="top-selling-tag">Top Selling</span>

              <h4 className="package-name">Growth Plan</h4>
              <button className="btn btn-light mb-3" onClick={() => navigate("/contact-us-hrias")}>Contact Sales</button>
              <ul
                className="feature-list"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  lineHeight: "1.8",
                  color: "white",
                }}
              >
                <li>
                  <strong>Data & Lead Generation</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Highly targeted 90% verified contact database
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    150 free verified leads per month — emails, company numbers, LinkedIn IDs and whatsapp numbers
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    1 lead = 1 credit
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Intents & signals targeting with global keyword research analysis
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Deliverability — 4 sending emails, 1 LinkedIn account, 1 WhatsApp number
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>Automated Outreach & Unlimited Follow-ups</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Unlimited automated outreach and follow-ups via email
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>Smart Mail Thread Sync & Auto-Personalize</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Automatically groups all outgoing and incoming lead emails into a single threaded sequence
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Dynamically replaces lead names in email drafts during campaign sends
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>Lead Sync Importer</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Import your leads up to 100 contacts
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>Multi-channel Follow-ups</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Auto LinkedIn visits, invites, and messages
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    WhatsApp messages with images
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>AI-powered Personalization</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Customized AI-generated templates for all communication channels
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>Integrated CRM</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Track Open, Reply, and Click-through rates
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Downloadable reports in PDF or CSV format
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>Enablement & Support</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    In-app live support
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Dedicated Account Manager
                  </li>
                </ul>
              </ul>

            </div>
          </div>

          {/* Box 3 - Enterprise Plan */}
          <div className="col-md-4 mb-4">
            <div className="pricing-box shadow-sm p-4 rounded h-100" style={{ border: "1px solid #e0e0e0", backgroundColor: "#fff", fontFamily: "Poppins, sans-serif" }}>
              <h4 className="package-name fw-bold text-center mb-3">Enterprise Plan</h4>
              <button className="btn btn-primary d-block mx-auto mb-3" onClick={() => navigate("/contact-us-hrias")}>Contact Sales</button>
              <div>
                <ul className="feature-list" style={{ lineHeight: "1.8" }}>
                  <li><strong>Data & Lead Generation</strong></li>
                  <ul className="ps-1 list-unstyled">

                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Highly targeted 90% verified contact database
                    </li>

                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      250 free verified leads per month — emails, company numbers, LinkedIn IDs and whatsapp numbers
                    </li>

                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      1 lead = 1 credit
                    </li>

                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Deliverability — 8 sending emails, 1 LinkedIn account, 1 WhatsApp number
                    </li>

                  </ul>

                  <li className="mt-2"><strong>Smart Mail Thread Sync & Auto-Personalize</strong></li>
                  <ul className="ps-1 list-unstyled">

                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Groups all lead emails into one thread
                    </li>

                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Auto name replacement in campaign sends
                    </li>

                  </ul>

                  <li className="mt-2"><strong>Lead Sync Importer</strong></li>
                  <ul className="ps-1 list-unstyled">

                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Import up to 200 contacts
                    </li>

                  </ul>

                  <li className="mt-2"><strong>AI-powered Personalization</strong></li>
                  <ul className="ps-1 list-unstyled">

                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      AI templates across all channels
                    </li>

                  </ul>

                  <li className="mt-2"><strong>Integrated CRM</strong></li>
                  <ul className="ps-1 list-unstyled">

                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Track Open, Reply & CTR
                    </li>

                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Export data as PDF/CSV
                    </li>

                  </ul>
                </ul>

              </div>
            </div>
          </div>
        </div>

        {/* Add-ons Box in New Line */}
        <div className="row justify-content-center mt-5">
          <div className="col-md-8">
            <div className="addons-box shadow-sm p-4 rounded text-center" style={{ backgroundColor: "#f0f4ff", border: "1px solid #cfe2ff" }}>
              <h5 className="fw-bold mb-3" style={{ color: "#0d6efd" }}>Add-ons & Extensions</h5>
              <ul className="text-start ps-5" style={{ lineHeight: "1.8" , listStyle: "none" }}>
                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  Integration with HubSpot and Salesforce
                </li>

                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  Unlimited lead imports
                </li>

                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  Built-in calling dialer with call recordings
                </li>

                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  Custom feature development within Hrias
                </li>

                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  Custom branded image templates for emails
                </li>

                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  Access verified phone numbers (1 phone = 5 credits)
                </li>

                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  Secure cloud storage for campaigns
                </li>
              </ul>


            </div>
          </div>
        </div>
      </section>

      <section className="container my-5 pricing-section">
        <div className="text-center mb-5">
          <h2 className="fw-bold">
            Choose <span style={{ color: '#fd7e14' }}>Your</span> Plan <span style={{ color: '#fd7e14' }}>- B2C</span>
          </h2>
          <p className="text-muted">Find the right package that fits your business needs.</p>
        </div>

        <div className="row justify-content-center">
          {/* Box 1 */}
          {/* Box 1 - Starter Plan */}
          <div className="col-md-4 mb-4">
            <div className="pricing-box">
              <h4 className="package-name">Starter Plan</h4>

              <button
                className="btn btn-primary mb-3"
                onClick={() => navigate("/contact-us-hrias")}
              >
                Contact Sales
              </button>

              <ul className="feature-list" style={{ fontFamily: "Poppins, sans-serif", lineHeight: "1.8" }}>

                {/* Data & Lead Generation */}
                <li><strong>Data & Lead Generation</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Highly targeted 90% verified contact database
                  </li>
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    50 free verified leads per month — Instagram IDs, Facebook IDs, WhatsApp Numbers
                  </li>
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    1 lead = 1 credit
                  </li>
                </ul>

                {/* Automated Outreach */}
                <li className="mt-2"><strong>Automated Outreach & Unlimited Follow-ups</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Unlimited automated outreach and follow-ups
                  </li>
                </ul>

                {/* Multi-channel Follow-ups */}
                <li className="mt-2"><strong>Multi-channel Follow-ups</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    WhatsApp messages with images
                  </li>
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Follow-ups via Instagram and Facebook
                  </li>
                </ul>

                {/* AI-powered Personalization */}
                <li className="mt-2"><strong>AI-powered Personalization</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Customized AI-generated templates (multi-channel)
                  </li>
                </ul>

                {/* Lead Sync Importer */}
                <li className="mt-2"><strong>Lead Sync Importer</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Import your leads up to 50 contacts
                  </li>
                </ul>

                {/* Integrated CRM */}
                <li className="mt-2"><strong>Integrated CRM</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Track Open, Reply, and Click-through rates
                  </li>
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Downloadable reports in PDF or CSV format
                  </li>
                </ul>

                {/* Enablement & Support */}
                <li className="mt-2"><strong>Enablement & Support</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    In-app live support
                  </li>
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Dedicated Account Manager
                  </li>
                </ul>

              </ul>
            </div>
          </div>



          {/* Box 2 - Growth Plan */}
          <div className="col-md-4 mb-4">
            <div className="pricing-box active-box position-relative">

              {/* 🔹 Top Selling Tag */}
              <span className="top-selling-tag">Top Selling</span>

              <h4 className="package-name">Growth Plan</h4>

              <button
                className="btn btn-light mb-3"
                onClick={() => navigate("/contact-us-hrias")}
              >
                Contact Sales
              </button>

              <ul
                className="feature-list"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  lineHeight: "1.8",
                  color: "white",
                }}
              >
                {/* Data & Lead Generation */}
                <li><strong>Data & Lead Generation</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Highly targeted 90% verified contact database
                  </li>
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    150 free verified leads per month — Instagram IDs, Facebook IDs, WhatsApp Numbers
                  </li>
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    1 lead = 1 credit
                  </li>
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Intents & signals targeting with global keyword research analysis
                  </li>
                </ul>

                {/* Automated Outreach */}
                <li className="mt-2"><strong>Automated Outreach & Unlimited Follow-ups</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Unlimited automated outreach and follow-ups
                  </li>
                </ul>

                {/* Lead Sync Importer */}
                <li className="mt-2"><strong>Lead Sync Importer</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Import your leads up to 100 contacts
                  </li>
                </ul>

                {/* Multi-channel Follow-ups */}
                <li className="mt-2"><strong>Multi-channel Follow-ups</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    WhatsApp messages with images
                  </li>
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Follow-ups via Instagram and Facebook
                  </li>
                </ul>

                {/* AI-powered Personalization */}
                <li className="mt-2"><strong>AI-powered Personalization</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Customized AI-generated templates (multi-channel)
                  </li>
                </ul>

                {/* Integrated CRM */}
                <li className="mt-2"><strong>Integrated CRM</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Track Open, Reply, and Click-through rates
                  </li>
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Downloadable reports in PDF or CSV format
                  </li>
                </ul>

                {/* Enablement & Support */}
                <li className="mt-2"><strong>Enablement & Support</strong></li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    In-app live support
                  </li>
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Dedicated Account Manager
                  </li>
                </ul>
              </ul>
            </div>
          </div>



          {/* Box 3 - Enterprise Plan */}
          <div className="col-md-4 mb-4">
            <div
              className="pricing-box shadow-sm p-4 rounded h-100"
              style={{
                border: "1px solid #e0e0e0",
                backgroundColor: "#fff",
                fontFamily: "Poppins, sans-serif",
              }}
            >
              <h4 className="package-name fw-bold text-center mb-3">Enterprise Plan</h4>
              <button className="btn btn-primary d-block mx-auto mb-3" onClick={() => navigate("/contact-us-hrias")}>Contact Sales</button>
              <div>
                <ul className="feature-list" style={{ lineHeight: "1.8" }}>

                  <li><strong>Data & Lead Generation</strong></li>
                  <ul className="ps-1 list-unstyled">
                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Highly targeted 90% verified contact database
                    </li>
                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      250 free verified leads per month — Instagram IDs, Facebook IDs, WhatsApp Numbers
                    </li>
                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Intents & signals targeting + Global keyword research analysis
                    </li>
                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Automated outreach and unlimited follow-ups
                    </li>
                  </ul>

                  <li className="mt-2"><strong>Lead Sync Importer</strong></li>
                  <ul className="ps-1 list-unstyled">
                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Import your leads up to 200 contacts
                    </li>
                  </ul>

                  <li className="mt-2"><strong>Multi-Channel Follow-ups</strong></li>
                  <ul className="ps-1 list-unstyled">
                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      WhatsApp messages with image
                    </li>
                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Follow-ups via Instagram and Facebook
                    </li>
                  </ul>

                  <li className="mt-2"><strong>AI-powered Personalization</strong></li>
                  <ul className="ps-1 list-unstyled">
                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Customized AI-generated templates (Multi-channel)
                    </li>
                  </ul>

                  <li className="mt-2"><strong>Integrated CRM</strong></li>
                  <ul className="ps-1 list-unstyled">
                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Open, Reply, Click-through Rates tracking
                    </li>
                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Downloadable PDF/CSV reports
                    </li>
                  </ul>

                  <li className="mt-2"><strong>Enablement & Support</strong></li>
                  <ul className="ps-1 list-unstyled">
                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      In-app live support with Dedicated Account Manager
                    </li>
                  </ul>

                </ul>
              </div>

            </div>
          </div>


        </div>

        {/* Add-ons Box in New Line */}
        <div className="row justify-content-center mt-5">
          <div className="col-md-8">
            <div
              className="addons-box shadow-sm p-4 rounded text-center"
              style={{ backgroundColor: "#f0f4ff", border: "1px solid #cfe2ff" }}
            >
              <h5 className="fw-bold mb-3" style={{ color: "#0d6efd" }}>
                Add-ons & Extensions
              </h5>

              <ul className="text-start ps-5" style={{ lineHeight: "1.8", listStyle: "none" }}>

                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  <strong>Integrations & Extensions –</strong> HubSpot, Salesforce
                </li>

                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  <strong>Lead Sync Importer –</strong> Import your leads to any number as per your choice, instantly integrated
                </li>

                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  <strong>Calling Dialer –</strong> Call recordings and download call summary
                </li>

                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  <strong>Custom Feature Development –</strong> Build any custom feature that you need in the portal
                </li>

                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  <strong>Custom Image Templates –</strong> Get image templates with visuals of your choice for emails
                </li>

                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  <strong>Phone Numbers of Leads –</strong> 1 phone number = 6 credits
                </li>

              </ul>
            </div>
          </div>

        </div>

      </section>


      <section className="faq-section" style={{ backgroundImage: `url(${servicebg})` }}>
        <motion.section className="container my-5"
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.6 }}
          transition={{ duration: 0.8, ease: "easeOut" }}>
          <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
            <div
              className="px-3 fw-bold responsive-heading"
            >
              Frequently    <span className="highlight-orange">Asked </span>Questions
            </div>
          </div>
          {/* <div className="d-flex justify-content-center mt-4">
                        <a
                            href="#contact-us"
                            className="btn custom-orange-btn py-3 px-4 fw-bold"
                        >
                            Book a Free Consultation
                        </a>
                    </div> */}
        </motion.section>
        <div className="container my-5">
          <div className="row g-4">
            {/* Column 1 */}
            <div className="col-12 col-md-6">
              <div className="accordion" id="accordionColumn1">
                {faqColumn1.map((faq, index) => (
                  <motion.div variants={fadeInUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    className="accordion-item shadow mb-3 rounded p-2"
                    key={index}
                    style={{ boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}
                  >
                    <h2 className="accordion-header" id={`heading1-${index}`}>
                      <button
                        className="accordion-button collapsed fw-bold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse1-${index}`}
                        aria-expanded="true"
                        aria-controls={`collapse1-${index}`}
                        style={{
                          fontWeight: '700',
                          backgroundColor: '#fff',
                          whiteSpace: 'normal',
                          wordBreak: 'break-word',
                          overflowWrap: 'break-word',
                        }}
                      >
                        {faq.question}
                      </button>
                    </h2>
                    <div
                      id={`collapse1-${index}`}
                      className="accordion-collapse collapse"
                      aria-labelledby={`heading1-${index}`}
                      data-bs-parent="#accordionColumn1"
                    >
                      <div
                        className="accordion-body"
                        style={{ backgroundColor: '#fff4e6' }}
                      >
                        {faq.answer}
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>

            {/* Column 2 */}
            <div className="col-12 col-md-6">
              <div className="accordion" id="accordionColumn2">
                {faqColumn2.map((faq, index) => (
                  <motion.div
                    variants={fadeInUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    className="accordion-item shadow mb-3 rounded p-2"
                    key={index}
                    style={{ boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}
                  >
                    <h2 className="accordion-header" id={`heading2-${index}`}>
                      <button
                        className="accordion-button collapsed fw-bold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse2-${index}`}
                        aria-expanded="true"
                        aria-controls={`collapse2-${index}`}
                        style={{
                          fontWeight: '700',
                          backgroundColor: '#fff',
                          whiteSpace: 'normal',
                          wordBreak: 'break-word',
                          overflowWrap: 'break-word',
                        }}
                      >
                        {faq.question}
                      </button>
                    </h2>
                    <div
                      id={`collapse2-${index}`}
                      className="accordion-collapse collapse"
                      aria-labelledby={`heading2-${index}`}
                      data-bs-parent="#accordionColumn2"
                    >
                      <div
                        className="accordion-body"
                        style={{ backgroundColor: '#fff4e6' }}
                      >
                        {faq.answer}
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>


    </>
  )
}

export default ProductPage